import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiPlus } from 'react-icons/fi';
import { useDepartments } from '../context/DepartmentContext';
export default function DepartmentHeader() {
  const { openForm } = useDepartments();
  return <header className="mb-6"><Link to="/users" className="inline-flex items-center gap-1 text-sm text-violet-700 hover:underline"><FiArrowLeft />Users</Link>
    <div className="mt-4 flex flex-wrap items-center justify-between gap-4"><div><h1 className="text-3xl font-bold tracking-tight text-slate-950">Departments</h1><p className="mt-2 text-sm text-slate-500">Manage departments and organise your team.</p></div>
      <button type="button" onClick={() => openForm()} className="inline-flex items-center gap-2 rounded-lg bg-violet-700 px-4 py-3 text-sm font-semibold text-white hover:bg-violet-800"><FiPlus />Add Department</button></div></header>;
}
